// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
enum AccountingDocumentsInventoryStatus {
  Created = "CREATED",
  ToBeChecked = "TO_BE_CHECKED",
  Checked = "CHECKED",
  CheckFailed = "CHECK_FAILED",
  Closed = "CLOSED",
}
export default AccountingDocumentsInventoryStatus;

export function accountingDocumentsInventoryStatusToVariant(status: AccountingDocumentsInventoryStatus): string {
  switch (status) {
    case AccountingDocumentsInventoryStatus.CheckFailed:
      return "danger";

    case AccountingDocumentsInventoryStatus.Closed:
    case AccountingDocumentsInventoryStatus.Checked:
      return "success";

    case AccountingDocumentsInventoryStatus.Created:
    case AccountingDocumentsInventoryStatus.ToBeChecked:
    default:
      return "gray";
  }
}
